module.exports = __webpack_public_path__ + "media/images/emblems/Echarlens-coat_of_arms-894f587097d763b60691958ddb49057e.svg";